import SpaceCraft from './space_craft/game'
import MemoryCards from './memory_cards/game'

const GamesLoader = (game) => {
    game.scene.add("SpaceCraft", SpaceCraft);
    game.scene.add("MemoryCards", MemoryCards);
}

export default GamesLoader